var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var isGinniOn = function () {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('ginni') === 'on' || localStorage.getItem('ginni') === '1';
  }
  return false;
};
var isVerboseGinniOn = function () {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('ginni') === 'verbose';
  }
  return false;
};
var unconditional = function () {
  return true;
};
var logFunc = function (check) {
  return function (message) {
    var others = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      others[_i - 1] = arguments[_i];
    }
    if (check()) {
      console.log.apply(console, __spreadArray([message], __read(others), false));
    }
  };
};
var infoFunc = function (check) {
  return function (message) {
    var others = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      others[_i - 1] = arguments[_i];
    }
    if (check()) {
      console.info.apply(console, __spreadArray([message], __read(others), false));
    }
  };
};
var warnFunc = function (check) {
  return function (message) {
    var others = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      others[_i - 1] = arguments[_i];
    }
    if (check()) {
      console.warn.apply(console, __spreadArray([message], __read(others), false));
    }
  };
};
var errorFunc = function (check) {
  return function (message) {
    var others = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      others[_i - 1] = arguments[_i];
    }
    if (check()) {
      console.error.apply(console, __spreadArray([message], __read(others), false));
    }
  };
};
var timeFunc = function (check) {
  return function (label) {
    if (check()) {
      console.time(label);
    }
  };
};
var timeEndFunc = function (check) {
  return function (label) {
    if (check()) {
      console.timeEnd(label);
    }
  };
};
var groupFunc = function (check) {
  return function (label) {
    if (check()) {
      console.group(label);
    }
  };
};
var groupEndFunc = function (check) {
  return function () {
    if (check()) {
      console.groupEnd();
    }
  };
};
var groupCollapsedFunc = function (check) {
  return function (label) {
    if (check()) {
      console.groupCollapsed(label);
    }
  };
};
var tableFunc = function (check) {
  return function (data) {
    if (check()) {
      console.table(data);
    }
  };
};
var traceFunc = function (check) {
  return function () {
    if (check()) {
      console.trace();
    }
  };
};
var clearFunc = function (check) {
  return function () {
    if (check()) {
      console.clear();
    }
  };
};
var countFunc = function (check) {
  return function (label) {
    if (check()) {
      console.count(label);
    }
  };
};
var countResetFunc = function (check) {
  return function (label) {
    if (check()) {
      console.countReset(label);
    }
  };
};
var assertFunc = function (check) {
  return function (condition, message) {
    var others = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      others[_i - 2] = arguments[_i];
    }
    if (check()) {
      console.assert.apply(console, __spreadArray([condition, message], __read(others), false));
    }
  };
};
// a wrapper for console which will only log if debug is on
export var ginni = {
  log: logFunc(isGinniOn),
  info: infoFunc(isGinniOn),
  warn: warnFunc(isGinniOn),
  error: errorFunc(isGinniOn),
  time: timeFunc(isGinniOn),
  timeEnd: timeEndFunc(isGinniOn),
  group: groupFunc(isGinniOn),
  groupEnd: groupEndFunc(isGinniOn),
  groupCollapsed: groupCollapsedFunc(isGinniOn),
  table: tableFunc(isGinniOn),
  trace: traceFunc(isGinniOn),
  clear: clearFunc(isGinniOn),
  count: countFunc(isGinniOn),
  countReset: countResetFunc(isGinniOn),
  assert: assertFunc(isGinniOn),
  always: {
    log: logFunc(unconditional),
    info: infoFunc(unconditional),
    warn: warnFunc(unconditional),
    error: errorFunc(unconditional),
    time: timeFunc(unconditional),
    timeEnd: timeEndFunc(unconditional),
    group: groupFunc(unconditional),
    groupEnd: groupEndFunc(unconditional),
    groupCollapsed: groupCollapsedFunc(unconditional),
    table: tableFunc(unconditional),
    trace: traceFunc(unconditional),
    clear: clearFunc(unconditional),
    count: countFunc(unconditional),
    countReset: countResetFunc(unconditional),
    assert: assertFunc(unconditional)
  },
  verbose: {
    log: logFunc(isVerboseGinniOn),
    info: infoFunc(isVerboseGinniOn),
    warn: warnFunc(isVerboseGinniOn),
    error: errorFunc(isVerboseGinniOn),
    time: timeFunc(isVerboseGinniOn),
    timeEnd: timeEndFunc(isVerboseGinniOn),
    group: groupFunc(isVerboseGinniOn),
    groupEnd: groupEndFunc(isVerboseGinniOn),
    groupCollapsed: groupCollapsedFunc(isVerboseGinniOn),
    table: tableFunc(isVerboseGinniOn),
    trace: traceFunc(isVerboseGinniOn),
    clear: clearFunc(isVerboseGinniOn),
    count: countFunc(isVerboseGinniOn),
    countReset: countResetFunc(isVerboseGinniOn),
    assert: assertFunc(isVerboseGinniOn)
  }
};